import baseTheme from '../baseTheme';
var MuiBreadcrumbs = {
    /* your custom class style overrides here */
    root: {
        fontSize: baseTheme.typography.pxToRem(baseTheme.typography.fontSize),
    },
};
export default MuiBreadcrumbs;
//# sourceMappingURL=MuiBreadcrumbs.js.map